var __rspack_ns_object = JSON.parse('{"Copied":"Скопировано","Failed to copy":"Ошибка при копировании"}')